angular.module('picmonicng').directive('quizPlaylist', [
  '$state',
  '$filter',
  'UserService',
  'PicmonicQueue',
  function ($state, $filter, UserService, PicmonicQueue) {
    return {
      restrict: 'A',
      scope: {
        target: '=quizPlaylist',
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          scope.$apply(function () {
            PicmonicQueue.goToQuiz(scope.target.playlist_id, 'playlist', scope.target.total_facts, scope.target.name);
          });
        });
      },
    };
  },
]);
